var map = {
	"./icon-flag-ar.png": 1005,
	"./icon-flag-en.png": 5517,
	"./icon-flag-es.png": 2376,
	"./icon-flag-fr.png": 3744,
	"./icon-flag-id.png": 6643,
	"./icon-flag-ko.png": 9270,
	"./icon-flag-pt.png": 3984,
	"./icon-flag-ru.png": 5059,
	"./icon-flag-uz.png": 6345,
	"./icon-flag-vi.png": 1075,
	"./icon-flag-zh.png": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5819;